import customConfirmationVnResponse from "../../../../src/content/vietnam-response-page/customConfirmation.js";
import { LandingPageResponse } from '@bgea-js/form-templates';
import * as React from 'react';
export default {
  customConfirmationVnResponse,
  LandingPageResponse,
  React
};